module.exports = __webpack_public_path__ + "static/media/0042.92c9ab7d.png";